module.exports = __webpack_public_path__ + "files/33c1ec25dbeef7d9b2916e7e752aea71.png";